import React from 'react';
import PropTypes from 'prop-types';
import styles from './EarningStatistic.pcss';
import {Icon, Message} from 'epic-diesel-common';
import {sizes, svgs} from 'epic-diesel-common/src/constants';
import Tip from '../../common/Tip';

const EarningStatistic = props => {
    const tipContent = (
        <div className={styles.tipContent}>
            <p>
                <Message code={props.tipTitle} />
            </p>
        </div>
    );

    return (
        <div className={styles.section}>
            <div className={styles.title}>
                <Message code={props.title} />
                <Tip className={styles.tip} content={tipContent} position="left">
                    <Icon icon={svgs.INFO} size={sizes.XSMALL} />
                </Tip>
            </div>
            {props.children}
        </div>
    );
};

EarningStatistic.propTypes = {
    title: PropTypes.string.isRequired,
    tipTitle: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
        .isRequired
};

export default EarningStatistic;
